import React from 'react';
import { useNavigate } from 'react-router-dom';
import wardHeadImage from '../images/ward-head.jpg';
import wardMember1 from '../images/oda-sadasya1.jpg';
import wardMember2 from '../images/oda-sadasya2.jpg';
import wardMember3 from '../images/oda-sadasya-3.jpg';
import wardMember4 from '../images/oda-sadasya-4.jpg';
import logo from '../images/nepal-government-logo.png';
import municipalityMapPage from '../images/municipality-map.jpg';

const LandingPage = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen flex flex-col">
      {/* Navbar */}
      <header className="fixed top-0 left-0 w-full bg-gray-100 border-b-2 border-red-500 shadow-md z-50 flex items-center justify-between p-4">
        <div className="flex items-center">
          <img src={logo} alt="Nepal Government Logo" className="h-16 mr-4" />
          <div>
            <h1 className="text-lg font-bold text-red-600">
              चन्द्रपुर नगरपालिका वडा ३
            </h1>
            <p className="text-sm text-red-500">रौतहट, मधेश प्रदेश, नेपाल</p>
          </div>
        </div>
        <button
          className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition"
          onClick={() => navigate('/login')}
        >
          Login
        </button>
      </header>

      <main className="flex-1 pt-20 px-4 sm:px-8 lg:px-16">
        {/* Logo and Welcome Message */}
        <section className="text-center mt-8 mb-12">
          <img src={logo} alt="Logo" className="w-16 h-16 mx-auto mb-4" />
          <h2 className="text-2xl font-bold mb-2">
            चन्द्रपुर नगरपालिका वडा ३ मा तपाईंलाई स्वागत छ।
          </h2>
          <p className="text-gray-600">रौतहट, मधेश प्रदेश, नेपाल</p>
        </section>

        {/* Ward-Head Section */}
        <section className="text-center mb-12">
          <div className="flex justify-center">
            <img
              src={wardHeadImage}
              alt="बोध नाथ देवकोटा"
              className="w-48 h-48 object-cover rounded-full mb-4"
            />
          </div>
          <h3 className="text-xl font-semibold">बोध नाथ देवकोटा</h3>
          <p className="text-gray-600">वडा अध्यक्ष</p>
          <p className="text-gray-600">९८५७०४१२०६</p>
        </section>

       {/* Ward Members Section */}
<section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 text-center mb-12">
  {[
    { img: wardMember1, name: 'रिस्ता घलान', title: 'वडा सदस्य', phone: '९८२१२३१४६४' },
    { img: wardMember2, name: 'जिस्मित विश्वकर्मा', title: 'वडा सदस्य', phone: '९८६४०१३१४३' },
    { img: wardMember3, name: 'जितेन्द्र राई', title: 'वडा सदस्य', phone: '९८१९२१५२१०' },
    { img: wardMember4, name: 'रित बहादुर राई', title: 'वडा सदस्य', phone: '९८६६४८६८७७' },
  ].map((member, index) => (
    <div key={index}>
      <img src={member.img} alt={member.name} className="w-48 h-48 object-cover rounded-full mx-auto mb-4" />
      <h4 className="text-lg font-semibold">{member.name}</h4>
      <p className="text-gray-600">{member.title}</p>
      <p className="text-gray-600">{member.phone}</p>
    </div>
  ))}
</section>


        <hr className="border-gray-300 mb-12" />

        {/* Introduction Section */}
        <section className="text-center px-4 sm:px-12 lg:px-32">
          <h3 className="text-2xl font-bold mb-4">संक्षिप्त परिचय</h3>
          <p className="text-gray-700 leading-relaxed">
          चन्द्रपुर नगरपालिकामा विविधता र गतिशीलताको मध्यविन्दुमा अवस्थित वडा मध्य आफ्नै विशिष्ट पहिचान र आकर्षण बोकेको वडा हो वडा नं. ३। 
      यो वडा चन्द्रपुर नगरपालिकाको उत्तर पश्चिम भेगमा पर्दछ। साथै यस वडा चन्द्रपुरको समृद्ध सांस्कृतिक विरासत, समुदायको सकिय जीवन, र 
      भविष्यको कृषि तथा पर्यटकीय सम्भावनाको रुप हो। यो भाग चन्द्रपुर भित्रको भौगोलिक समिश्रण मात्र नभई परम्परा र आधुनिकताको सहज 
      समिश्रण पनि हो। वडा नं. ३ को आफ्नो आवासीय क्षेत्र, बजार, शैक्षिक संस्थान, स्रोत साधन र हरियाली क्षेत्रको यथास्थिती यहाहरु 
      समक्ष प्रस्तुत गरिएको छ। यहाँ वडाको व्यापक जनसंख्या, संस्कृतिक , स्रोत साधन र अन्य विविधताको एक सुक्ष्म अवलोकन प्रधान गराइएको छ।
          </p>
          <div className="mt-8">
            <img
              src={municipalityMapPage}
              alt="Map"
              className="w-full max-w-sm mx-auto"
            />
            <p className="text-sm text-gray-500 mt-2">
              चित्र: चन्द्रपुर नगरपालिका वडा ३ को नक्शा
            </p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default LandingPage;
